import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [status, setStatus] = useState("idle");

  const sendEmail = async (event) => {
    event.preventDefault();
    setStatus("sending");

    try {
      await emailjs.sendForm(
        "service_j1l52o7",
        "template_mpc1ja8",
        event.target,
        "A5uq8fgtKxlrfjWP6"
      );
      event.target.reset();
      setStatus("sent");
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <form className="contact-form" onSubmit={sendEmail}>
      <div className="form-grid">
        <label>
          Name
          <input name="name" placeholder="Your name" required type="text" />
        </label>

        <label>
          Contact Number
          <input name="number" placeholder="Your phone number" required type="text" />
        </label>

        <label>
          Email
          <input
            name="email"
            placeholder="Your email address"
            required
            type="email"
          />
        </label>

        <label>
          Enquiry Type
          <select defaultValue="Grey Transition" name="enquiry_type">
            <option>Grey Transition</option>
            <option>Colour Analysis</option>
            <option>General Enquiry</option>
          </select>
        </label>
      </div>

      <label>
        Any information you think would be helpful for Lizzie to know? (optional)
        <textarea
          name="message"
          placeholder="Share anything useful about your enquiry, your goals, your current hair, or any questions you would like Lizzie to know before replying."
          rows="6"
        />
      </label>

      <button className="button button--solid" disabled={status === "sending"} type="submit">
        {status === "sending" ? "Sending..." : "Send Enquiry"}
      </button>

      {status === "sent" && (
        <p className="form-status form-status--success">
          Thanks. Your message has been sent successfully.
        </p>
      )}

      {status === "error" && (
        <p className="form-status form-status--error">
          Something went wrong while sending your enquiry. Please email Lizzie
          directly at lizzie@lizziefoxhair.co.uk.
        </p>
      )}
    </form>
  );
};

export default ContactForm;
